<template>
  <RedirectQr/>
</template>

<script>
import RedirectQr from './components/RedirectQr.vue'

export default {
  name: 'App',
  components: {
    RedirectQr
  }
}
</script>

<style>


#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
